module.exports = __webpack_public_path__ + "img/our_focus_bg.c438b3bd.png";